import { render, staticRenderFns } from "./IntegrationStatus.vue?vue&type=template&id=8846163c&"
import script from "./IntegrationStatus.vue?vue&type=script&lang=js&"
export * from "./IntegrationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports